// Copyright © 2024 Broadcom Inc. and its subsidiaries. All Rights Reserved.
import axios from 'axios';
import { get } from 'lodash';
import { AXIOS_DEFAULT_OPTIONS } from '..';
import { getConfig } from '../../reducers/portalConfig';
import * as Constants from '../../constants';

export const fetchRegistrationSettings = () =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const regConfigURL = `${portal.hostname}/admin/registrationConfigurations`;
    const inactiveUsersURL = `${portal.hostname}/api/${portal.tenantPrefix}/tenant-admin/1.0/settings/REMOVE_INACTIVE_USERS`;
    const regConfigPromise = axios.get(regConfigURL, AXIOS_DEFAULT_OPTIONS);
    const inactiveUsersPromise = axios.get(inactiveUsersURL, AXIOS_DEFAULT_OPTIONS);
    dispatch({ type: Constants.REGISTRATION_SETTINGS_GET_REQUEST });

    Promise.all([regConfigPromise, inactiveUsersPromise])
    .then((values) => {
      const configData = get(values, '0.data', {});
      const usersSettingString = get(values, '1.data.value', '{}');
      const usersSettingData = JSON.parse(usersSettingString);
      dispatch({
        type: Constants.REGISTRATION_SETTINGS_GET_SUCCESS,
        payload: {
          ...configData,
          ...usersSettingData,
        },
      });
    })
    .catch(() => {
      dispatch({
        type: Constants.REGISTRATION_SETTINGS_GET_ERROR,
        payload: [''],
      });
    });
  };

const getSettingsData = (data = {}) => ({
  name: "REMOVE_INACTIVE_USERS",
  uuid: '00000000-0000-0000-0000-000000000000',
  value: JSON.stringify(data),
});

export const updateRegistrationSettings = (data) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    dispatch({ type: Constants.REGISTRATION_SETTINGS_UPDATE_REQUEST });
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };
    const regConfigURL = `${portal.hostname}/admin/registrationConfigurations`;
    const inactiveUsersURL = `${portal.hostname}/api/${portal.tenantPrefix}/tenant-admin/1.0/settings/REMOVE_INACTIVE_USERS`;

    const {
      thresholds,
      deleteInactiveUsersAfter,
      enabled,
      notificationEnabled,
      registrationStatus,
      removeAdminUsers,
      userRegistrationLimitEnabled,
      userRegistrationLimitId,
      termOfUse,
    } = data;

    const settingsData = getSettingsData({
      thresholds,
      deleteInactiveUsersAfter,
      enabled,
      notificationEnabled,
      removeAdminUsers,
    });

    const regConfigData = {
      registrationStatus,
      userRegistrationLimitEnabled,
      userRegistrationLimitId,
      termOfUse,
    };

    const regConfigPromise = axios.put(regConfigURL,
      regConfigData, { headers }, AXIOS_DEFAULT_OPTIONS);
    const inactiveUsersPromise = axios.put(inactiveUsersURL,
      settingsData, { headers }, AXIOS_DEFAULT_OPTIONS);

    Promise.all([regConfigPromise, inactiveUsersPromise])
    .then((values) => {
      dispatch({
        type: Constants.REGISTRATION_SETTINGS_UPDATE_SUCCESS,
        payload: values,
      });
    })
    .catch((error) => {
      dispatch({
        type: Constants.REGISTRATION_SETTINGS_UPDATE_ERROR,
        payload: get(error, 'response.data'),
      });
    });
  };
